<template>
    <div>
        <b-modal
            id="cancelModal"
            ref="cancelModal"
            :lazy="true"
            @hidden="close"
            :scrollable="true"
            title-tag="h2"
            title="Cancel Appointment"
        >
            <!-- Modal Form -->
            <form class="form-horizontal pl-2">
                <b-form-group
                    :label-for="`reason`"
                    label="Reason:"
                    class="mb-0"
                    label-cols="2"
                >
                    <select
                        id="reason"
                        v-model="cancellation_reason"
                        class="form-control col"
                    >
                        <option
                            v-for="reason in cancellation_reasons"
                            :key="reason.id"
                            :value="reason.id"
                            >{{ reason.name }}</option
                        >
                    </select>
                </b-form-group>
                <b-form-group
                    :label-for="`save_event_type`"
                    v-if="data.id != null && data.repeat > 1"
                    class="mb-0"
                    label-cols="2"
                    label="Apply To:"
                >
                    <b-form-select
                        v-model="save_event_type"
                        :value="1"
                        name="save_event_type"
                        class="form-control"
                        aria-invalid="false"
                    >
                        <option value="1">Only this event</option>
                        <option value="2">This and following events</option>
                        <option value="3">All events</option>s
                    </b-form-select>
                </b-form-group>
                <b-form-group
                    :label-for="`reject_cancellation_note`"
                    label="Notes:"
                    class="mb-0"
                    label-cols="2"
                >
                    <textarea
                        id="reject_cancellation_note"
                        v-model="cancellation_note"
                        class="form-control"
                        placeholder="Notes (optional)"
                        rows="3"
                    ></textarea>
                </b-form-group>
            </form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.cancelModal.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button @click="save" v-else variant="primary"
                        >Save</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import CensusMixin from "@/mixins/census";

import ScheduleHelper from "@/module/schedule/helper";
export default {
    components: {},
    mixins: [ScheduleHelper, CensusMixin],
    props: {
        instanceId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            resources: {},
            data: {
                client: {},
                patient: {}
            },
            confirmation_message: null,
            cancellation_reason: null,
            cancellation_reasons: [],
            cancellation_note: null,
            save_event_type: 1,
            loading: false
        };
    },
    methods: {
        open(id) {
            let self = this;
            self.loading = true;
            self.getAppointmentData(id).then(() => {
                self._getCancellationReasonOptions().then(response => {
                    self.cancellation_reasons = response;
                    self.cancellation_reason = self.cancellation_reasons[0].id;

                    self.loading = false;
                });
            });

            self.$refs.cancelModal.show();
        },
        close() {
            this.$socket.client.emit("v-broadcast-all", { action: "cancel" });
        },
        getAppointmentData(id) {
            let self = this;
            return self.$http
                .get(process.env.SCHEDULE_SERVICE + "appointment/" + id)
                .then(function (response) {
                    self.data = response.data.response.resources;

                    self.data.start = moment(self.data.start);
                    self.data.end = moment(self.data.end);
                });
        },
        save(id) {
            let self = this;
            let promise = null;
            let params = {};
            self.loading = true;
            if (self.page == "appointment") {
                promise = self.$refs.appointment.$validator.validateAll();
            } else {
                promise = Promise.resolve(true); // -- empty promise
            }

            params.cancellation_note = this.cancellation_note;
            params.cancellation_reason = this.cancellation_reason;
            params.save_event_type = this.save_event_type;
            promise.then(result => {
                if (result) {
                    return self.$http
                        .delete(
                            process.env.SCHEDULE_SERVICE +
                                "appointment/" +
                                self.data.id,
                            {
                                params: {
                                    cancellation_note: params.cancellation_note,
                                    cancellation_reason:
                                        params.cancellation_reason,
                                    save_event_type: params.save_event_type
                                }
                            }
                        )
                        .then(function (response) {
                            self._message(
                                response.data.response.message.description
                            );
                            self.loading = false;
                            self.$refs.cancelModal.hide();
                            self.$parent.refetch();

                            // Emit socket to refresh census
                            const payload = {
                                appointmentDate: self.data.start?.unix(),
                                appointmentId: self.data?.id,
                                instanceId: self.instanceId
                            };

                            self.refreshCensus(payload);
                        });
                }
            });
        }
    }
};
</script>
